import {
    Grid
} from "@material-ui/core";
import { ProfileEnum } from "../../../../utils/general-profile.enum";
import { AcademicPeriodFilter } from "./filters/academic-period-filter";
import { ClassFilter } from "./filters/class-filter";
import { InstitutionBranchFilter } from "./filters/institution-branch-filter";
import { InstitutionFilter } from "./filters/institution-filter";
import { ThemeFilter } from "./filters/theme-filter";
import { dashboardStyles } from "./styles";

const DASHBOARD_FILTER_CONFIG = {
    institutionId: { label: 'Instituição', component: InstitutionFilter, },
    institutionBranchId: { label: 'Unidade', component: InstitutionBranchFilter, },
    academicPeriodId: { label: 'Período Letivo', component: AcademicPeriodFilter, },
    classId: { label: 'Turma', component: ClassFilter, },
    themeId: { label: 'Área do Direito', component: ThemeFilter, },
};

const DASHBOARD_FILTERS_BY_PROFILE = {
    [ProfileEnum.SUPERADMIN]: [
        'institutionId',
        'institutionBranchId',
        'academicPeriodId',
        'classId',
        'themeId',
    ],

    [ProfileEnum.GENERAL_PRINCIPAL]: [
        'institutionBranchId',
        'academicPeriodId',
        'classId',
        'themeId',
    ],

    [ProfileEnum.ADMIN]: [
        'academicPeriodId',
        'classId',
        'themeId',
    ],
};


export const DashboardFilters = ({ profile, filters, setFilters }) => {

    const classes = dashboardStyles();

    return (
        <Grid item container spacing={1}>
            {
                DASHBOARD_FILTERS_BY_PROFILE[profile].map(filterKey => {
                    const config = DASHBOARD_FILTER_CONFIG[filterKey];
                    const Component = config.component;

                    return (
                        <Grid
                            item
                            xs={12}
                            md={Math.floor(12 / DASHBOARD_FILTERS_BY_PROFILE[profile].length)}
                            key={filterKey}
                        >
                            <Component
                                profile={profile}
                                filters={filters}
                                setFilters={setFilters}
                            />
                        </Grid>
                    );
                })
            }
        </Grid>
    )
}